export default {
  '@global': {
    body: { fontSize: '0.875rem' }
  }
}
